import { useStakeButton } from '@plug-core/hooks/useStaking'
import { StakeButtonProps } from '@plug-core/interfaces/staking'
import { Button } from '@ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const StakeButton = ({ isLoading, ...props }: StakeButtonProps) => {
  const { t } = useTranslation()
  const { userError, reviewStake } = useStakeButton(props)

  return (
    <Button
      variant="primary"
      disabled={!!userError || isLoading}
      onClick={reviewStake}
      fullWidth={true}
    >
      {userError || t('stake.stakeIcp')}
    </Button>
  )
}
